"use client";

import { useMergeRefs } from "@floating-ui/react";
import React, { isValidElement, cloneElement } from "react";

import { useFloatingContext } from "../floating/FloatingContext";

type IProps = React.HTMLProps<HTMLElement>;

export const PopoverTrigger: React.FC<IProps> = ({
  children,
  ref: propRef,
  ...props
}) => {
  const { refs, propGetters, open } = useFloatingContext();
  const childrenRef = isValidElement(children)
    ? (children.props as unknown as { ref?: React.Ref<HTMLElement> })?.ref
    : undefined;
  const ref = useMergeRefs([refs.setReference, propRef, childrenRef]);

  if (!isValidElement(children)) {
    // oxlint-disable-next-line no-console
    console.error("PopoverTrigger must have a valid child element");
    return null;
  }

  return cloneElement(
    children,
    propGetters.getReferenceProps({
      ...props,
      ...(children.props as Record<string, unknown>),
      ref,
      "data-state": open ? "open" : "closed",
    } as Record<string, unknown>)
  );
};
